import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';
import { useStore } from '../lib/store';

interface PromptEditorProps {
  type: 'reel' | 'long' | 'short';
  title: string;
  onClose: () => void;
}

export const PromptEditor = ({ type, title, onClose }: PromptEditorProps) => {
  const { prompts, updatePrompt, user } = useStore();
  const [promptContent, setPromptContent] = useState(prompts[type] || '');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setPromptContent(prompts[type] || '');
  }, [prompts, type]);

  const handleSave = async () => {
    if (!user) return;
    
    setIsSaving(true);
    try {
      await updatePrompt(type, promptContent);
      onClose();
    } catch (error) {
      console.error('Error saving prompt:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold text-amber-500">{title} Prompt</h3>
        <button
          onClick={onClose}
          className="p-2 rounded-lg hover:bg-gray-800 transition-colors"
        >
          <X className="w-5 h-5 text-gray-400" />
        </button>
      </div>

      <textarea
        value={promptContent}
        onChange={(e) => setPromptContent(e.target.value)}
        className="w-full h-96 bg-gray-800 border border-gray-700 rounded-lg p-4 text-gray-200 focus:border-amber-500 focus:ring-1 focus:ring-amber-500"
        placeholder="Enter your custom prompt..."
      />

      <div className="flex justify-end">
        <button
          onClick={handleSave}
          disabled={isSaving}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-amber-500 hover:bg-amber-600 transition-colors disabled:opacity-50 text-gray-900"
        >
          <Save className="w-4 h-4" />
          {isSaving ? 'Saving...' : 'Save Prompt'}
        </button>
      </div>
    </div>
  );
};